import { OptionsHttpService } from "@/api/http/OptionsHttpService";
import type { Options } from "@/types/OptionsTypes";
import { createGlobalState, useLocalStorage } from "@vueuse/core";
import { useReadonlyWithSetter } from "@/composables/common";
import { computed } from "vue";

const useOptionsState = createGlobalState(() => {
  const [options, setOptions] = useReadonlyWithSetter(
    useLocalStorage<Options | null>("options", null, {
      serializer: {
        read: (v: string | null) => (v ? JSON.parse(v) : null),
        write: (v: Options | null) => JSON.stringify(v ?? {}),
      },
    })
  );

  const documentTypeDropdownOptions = computed(() => {
    const fileTypeOptions = options.value?.file_types;

    if (!fileTypeOptions) {
      return [];
    }

    return Object.values(fileTypeOptions)
      .flatMap((value) => value.categories)
      .map((category) => ({ id: category.type, label: category.name }));
  });

  const getOptions = async () => {
    const data = await new OptionsHttpService().getOptions();
    setOptions(data);
  };

  return { options, getOptions, setOptions, documentTypeDropdownOptions };
});

export default useOptionsState;
